<template>
  <div class="asc-power-bi-workspace-grid">
    <asc-ag-grid-filter
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscFolderCellRenderer,
  AscDrillDownCellRenderer,
} from '@/components/agGrid'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscPowerBiWorkspaceGrid',

  components: {
    AscAgGridFilter,
    AscFolderCellRenderer,
    AscDrillDownCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    updateSelectedWorkspace: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          floatingFilter: false,
        },
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    agGridRowData() {
      return this.values
    },
    getGridColumnDefs() {
      return [
        {
          headerName: '',
          field: 'id',
          cellRenderer: 'AscFolderCellRenderer',
          width: 44,
          minWidth: 44,
          maxWidth: 44,
          sortable: false,
        },
        {
          headerName: 'Airline',
          field: 'friendlyName',
          cellClass: ['ag-cell--drill', 'ag-cell--drill-ripple'],
          cellRenderer: 'AscDrillDownCellRenderer',
        },
      ]
    },
  },

  methods: {
    handleCellClicked(event) {
      if (event) {
        const field = event.colDef.field
        switch (field) {
          case 'friendlyName': {
            this.updateSelectedWorkspace(event.data)
            break
          }
          default:
            break
        }
      }
    },
  },
}
</script>

<style lang="scss">
.asc-power-bi-workspace-grid {
  .ag-theme-balham {
    height: 360px I !important;
  }

  .asc-sort-icon {
    color: $primary_black;
    position: absolute;
    top: 14px;
    right: 16px;
  }

  .asc-filter-icon {
    color: $primary_black;
  }

  .asc-grid-wrapper-header--container {
    .asc-grid-wrapper-header-buttons--container {
      .row {
        .col:first-child {
          margin-right: 10px;
        }
      }
    }
  }

  .asc-grid-drill-down-cell {
    .asc-value {
      color: $primary_black;

      &:hover {
        color: $accent-800;
      }
    }
  }
}
</style>
